import { useEmbedStore } from './embedStore';

export function goBackOrHome(navigate: (to: any, opts?: any) => void) {
  const isEmbed = useEmbedStore.getState().isEmbed;
  if (isEmbed) {
    navigate('/my-office');
  } else {
    navigate(-1 as any);
  }
}

export default goBackOrHome;
